import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function SlowStockCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.opsSlowChart !== 'undefined') {
      window.opsSlowChart.canvas = chartRef.current;
      window.opsSlowChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Slow-Moving Stock (₹L)</h3>
        <span className="click-tag">Click bars for bucket detail</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="opsSlowChart" ref={chartRef}></canvas>
      </div>
    </Box>
  );
}
